<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 md12 lg12>
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Donazioni</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu
              ref="datePicker"
              v-model="datePicker"
              :close-on-content-click="false"
              :return-value.sync="dates"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateRangeText"
                  label="Date filter"
                  append-icon="mdi-calendar"
                  v-on="on"
                  readonly
                  single-line
                  hide-details
                  max-width="100px"
                  clear
                ></v-text-field>
              </template>

              <v-date-picker v-model="dates" no-title range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="datePicker = false"
                  >Cancel</v-btn
                >
                <v-btn text color="primary" @click="getDonations()">OK</v-btn>
              </v-date-picker>
            </v-menu>

            <v-text-field
              v-model="tableSearch"
              append-icon="mdi-table-search"
              label="Search..."
              single-line
              hide-details
              class="ml-4"
            ></v-text-field>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="tableData"
              :options.sync="options"
              :server-items-length="totalData"
              :loading="loading"
              :search="tableSearch"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-file-input
                    accept=".csv, .json"
                    label="Carica donazioni"
                    ref="file"
                    @change="fileUpload()"
                    single-line
                    hide-details
                  ></v-file-input>
                  <v-btn @click="submitFile()" class="ml-4" primary
                    >Upload</v-btn
                  >
                </v-toolbar>
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                <v-icon small @click="deleteItem(item)">delete</v-icon>
              </template>

              <template v-slot:item.name="{ item }">
                <a @click="goToNpo(item)" dark>{{ item.name }}</a>
              </template>
              <template v-slot:item.insertdate="{ item }">{{
                item.insertdate | epochToDate
              }}</template>
              <template v-slot:no-data>
                Nessun dato trovato
                <v-btn color="primary" @click="initialize">Ricarica</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import Table from '@/components/Table';
import apiService from '@/services'

import moment from 'moment'

// const apiService = new ApiService();

export default {
  data () {
    return {
      dates: [],
      datePicker: false,
      tableSearch: '',
      totalData: 0,
      tableData: [],
      loading: true,
      options: {},
      donationsCsv: '',
      tableHeaders: [
        { text: 'Id Json', value: 'jsonid' },
        { text: 'Data inserimento', value: 'insertdate' },
        { text: 'Nome NPO', value: 'name' },
        { text: 'Codice fiscale', value: 'npofc' },
        { text: 'Totale', value: 'amount' }
      ]
    }
  },
  computed: {
    dateRangeText () {
      return this.dates.join(' ~ ')
    }
  },
  watch: {
    options: {
      handler () {
        this.getDonations()
      },
      deep: true
    }
  },
  mounted () {
    // this.getDataFromApi()
    this.getDonations()
  },
  filters: {
    epochToDate: function (date) {
      return moment.unix(date).format('DD MM YYYY, h:mm')
    }
  },
  methods: {
    // Upload file su variabile del componente
    fileUpload () {
      console.log(this.$refs.file)
      this.file = this.$refs.file.lazyValue
    },

    // Upload del file su BE solo csv
    submitFile () {
      console.log('submitFile')
      let formData = new FormData()
      if (this.file.name) {
        console.log('Uploading CSV...')
        formData.append('file', this.file)
        apiService.upload(formData)
      }
    },

    goToNpo (item) {
      this.$router.push({
        path: 'npos/' + item.npofc,
        params: { fiscalCode: item.npofc }
      })
    },

    setDateFilter (dates) {
      console.log(this.dates)
    },

    // GET delle donazioni
    // To Do aggiungere ricerca e date
    getDonations () {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let filter = {}
      console.log('dates')
      console.log(this.dates)
      if (this.dates.length > 0) {
        filter.startDate = moment(this.dates[0]).unix()
        filter.endDate = moment(this.dates[1]).unix()
      }
      filter.sortBy = sortBy[0] || null
      filter.sortDesc = sortDesc[0] || null
      filter.page = page
      filter.itemsPerPage = itemsPerPage

      apiService.fetchData('donations', filter).then((data) => {
        this.tableData = data
        this.totalData = data.lenght
        setTimeout(() => {
          this.loading = false
        }, 1000)
      })
    },
    getMontlyDonationsAmnt (params) {
      // To Do aggiungere GET totale mensile donazioni, passare data
    },
    complete (index) {
      this.list[index] = !this.list[index]
    }
  }
}
</script>
